var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_footer",class:{ p: _vm.p }},[_vm._v("本服务由北京赛福哈博保险经纪有限公司提供")])
}
var staticRenderFns = []

export { render, staticRenderFns }